import React, { useState } from 'react';
import EditLeadCereales from '../leadedit/editleadcereales';
import { List, Typography, Button, Col, Row, Modal } from 'antd';
import {SettingOutlined} from '@ant-design/icons';
const { Title } = Typography;

const LeadCereales = ({ dataLead, setIsInitialRender }) => {
    const [visible, setVisible] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setIsInitialRender(true);
            setVisible(false);
            setConfirmLoading(false);
        }, 500);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    let cereales = JSON.parse(dataLead[0].cereales.split());
    return (
        <>
        <List
          size="small"
          header={
          <Row gutter={[24, 24]}>
            <Col span={21}>
              <Title level={5}>Les céréales que vous souhaitez inclure :</Title>
            </Col>
            <Col span={3}>
            <Button onClick={showModal} key="1" type="primary" shape="circle" icon={<SettingOutlined />} />
            </Col>
          </Row>}
          bordered
          dataSource={cereales}
          renderItem={(item) => <List.Item>{item}</List.Item>}
          />

        <Modal
            title="Cochez les céréales que vous souhaitez inclure :"
            visible={visible}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            footer={null}
        >
           <EditLeadCereales dataLead={dataLead} handleOk={handleOk} handleCancel={handleCancel} confirmLoading={confirmLoading}/>
        </Modal>
        </>
        );
    }
    export default LeadCereales;